import { SagaNodeStatus, sagaNodeStatusColor, sagaNodeStatusLabel } from '@/dtos/SagaWorkflow'
import { useSagaWorkflowStream } from '@/hooks/useSagaWorkflowStream'
import { Box, Flex, Spinner, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons'
import { EDGE_COLOR } from './edgeStyle'
import { sagaNodeKindFlags } from './kindVisuals'
import { SagaWorkflowDiagram } from './SagaWorkflowDiagram'

const STATUS_LEGEND_ORDER = [SagaNodeStatus.Active, SagaNodeStatus.Done, SagaNodeStatus.Failed, SagaNodeStatus.Pending]

const Legend = () => (
  <Box mb={2}>
    <Flex gap={4} wrap="wrap">
      {STATUS_LEGEND_ORDER.map(s => (
        <Flex key={s} align="center" gap={1}>
          <Box w={3} h={3} borderRadius="sm" bg={`${sagaNodeStatusColor[s]}.400`} />
          <Text fontSize="xs" color="gray.600">{sagaNodeStatusLabel[s]}</Text>
        </Flex>
      ))}
    </Flex>
    <Flex gap={4} wrap="wrap" mt={1}>
      {sagaNodeKindFlags.map(f => (
        <Flex key={f.flag} align="center" gap={1} color="gray.500">
          <FontAwesomeIcon icon={f.icon} />
          <Text fontSize="xs" color="gray.600">{f.label}</Text>
        </Flex>
      ))}
      <Flex align="center" gap={1} color="gray.500">
        <FontAwesomeIcon icon={faArrowRotateRight} />
        <Text fontSize="xs" color="gray.600">Smyčka = pokusy na tomto stavu (najetím zobrazíte)</Text>
      </Flex>
    </Flex>
    <Flex gap={4} wrap="wrap" mt={1}>
      <Flex align="center" gap={1}>
        <Box w={5} borderTopWidth="2px" borderColor={EDGE_COLOR.taken} />
        <Text fontSize="xs" color="gray.600">Proběhlo</Text>
      </Flex>
      <Flex align="center" gap={1}>
        <Box w={5} borderTopWidth="2px" borderColor={EDGE_COLOR.available} />
        <Text fontSize="xs" color="gray.600">Možný přechod z aktuálního stavu</Text>
      </Flex>
      <Flex align="center" gap={1}>
        <Box w={5} borderTopWidth="2px" borderStyle="dashed" borderColor={EDGE_COLOR.unreachable} />
        <Text fontSize="xs" color="gray.600">Nedostupné z aktuálního stavu</Text>
      </Flex>
    </Flex>
  </Box>
)

/**
 * The live saga workflow diagram for the error-detail screen: fetches the snapshot, then streams updates.
 * onUpdate fires on every live push so the enclosing page can refresh its own saga-derived data alongside the diagram.
 */
export const SagaWorkflowSection = ({ rootId, onUpdate }: { rootId: string; onUpdate?: () => void }) => {
  const { graph, isLoading, isError } = useSagaWorkflowStream(rootId, onUpdate)

  if (isLoading && !graph) return <Box py={4}><Spinner size="sm" /></Box>
  if (isError || !graph) return <Text py={2} color="gray.500">Diagram není k dispozici.</Text>

  return (
    <Box>
      <Legend />
      <SagaWorkflowDiagram graph={graph} />
    </Box>
  )
}
